import { css, keyframes } from "@emotion/react";
import { useTheme } from "../theme";

const shimmerKeyframe = keyframes`
    100%{
        transform: translateX(100%);
    }
`;

export const useShimmerEffect = () => {
  const theme = useTheme();
  return css`
    && {
      overflow: hidden;
      color: transparent;
      cursor: default;
      background-color: ${theme.palette.gray[300]};
      border-color: ${theme.palette.gray[300]};
      box-shadow: none;
      &::before {
        all: initial;
        display: none;
      }
      &::after {
        all: initial;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        transform: translateX(-100%);
        animation: ${shimmerKeyframe} 2s infinite;
      }
    }
  `;
};
